module.exports = __webpack_public_path__ + "img/point2.c37d800b.png";